import { render, staticRenderFns } from "./daHuoList.vue?vue&type=template&id=21aacbb4&scoped=true&"
import script from "./daHuoList.vue?vue&type=script&lang=js&"
export * from "./daHuoList.vue?vue&type=script&lang=js&"
import style0 from "./daHuoList.vue?vue&type=style&index=0&id=21aacbb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21aacbb4",
  null
  
)

export default component.exports